import {
  api,
  apiInternal,
  ApiListResponse,
  commonApiWrapper,
} from "@/services/common-api";
import { ILocationV2 } from "@/app/dashboard/models/Location";

export const getLocations = () =>
  commonApiWrapper<ApiListResponse<ILocationV2>>(
    apiInternal.get("/location/all", {
      params: {
        offset: 0,
        limit: 100,
      },
    })
  );
export const getLocationNames = () =>
  commonApiWrapper<ApiListResponse<ILocationV2>>(
    api.get("/location/names", {
      params: {
        offset: 0,
        limit: 100,
      },
    })
  );
